<template>
    <address>
        <div class="columns is-vcentered is-multiline is-mobile">
            <div class="column is-2">
                <span class="icon">
                    <i class="fas fa-building"></i>
                </span>
            </div>
            <div class="column is-10">
                <strong style="font-family: IRANsans">
                  {{ $t('contact:address.name') }}
                </strong>
                <p class="is-size-6 small-container uptin-text-7">
                {{ $t('contact:address.organization_name') }}
                </p>
            </div>
            <div class="column is-2" v-if="isPersian(currentLocale)">
                <span class="icon">
                    <i class="fas fa-map-marker-alt"></i>
                </span>
            </div>
            <div class="column is-10" v-if="isPersian(currentLocale)">
                <strong style="font-family: IRANsans">
                  {{ $t('contact:address.address') }}
                </strong>
                <p class="is-size-6 small-container uptin-text-7">
                {{ $t('contact:address.ob_address') }}
                </p>
            </div>
            <div class="column is-2">
                <span class="icon">
                    <i class="fas fa-envelope"></i>
                </span>
            </div>
            <div class="column is-10">
                <strong style="font-family: IRANsans">
                  {{ $t('contact:address.email') }}
                </strong>
                <br/>
                <a href="mailto:info@uptinptt.ir">
                    info@uptinptt.ir
                </a>
            </div>
            <div class="column is-2">
                <span class="icon">
                    <i class="fas fa-globe"></i>
                </span>
            </div>
            <div class="column is-10">
                <strong style="font-family: IRANsans">
                  {{ $t('contact:address.website') }}
                </strong>
                <br/>
                <a href="https://www.uptinptt.ir" target="_blank">
                    www.uptinptt.ir
                </a>
            </div>
        </div>
    </address>
</template>

<script>
    export default {
        name: 'ob-address',
        data() {
            return {
                currentLocale: this.$i18n.i18next.language || window.localStorage.i18nextLng
            };
        },
        methods: {
            isPersian(locale) {
                return locale.toLowerCase() === 'fa' || locale.toLowerCase() === 'ar';
            }
        }
    }
</script>
